// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { useHistory } from 'react-router-dom';
import RowActions from '../../dashboard/RowActions';

const LabelRow = ({
  template,
  deleteTemplate,
  copy,
}) => {
  const history = useHistory();

  return (
    <tr>
      <td>
        <span className="row-name">{template.label}</span>
      </td>
      <td className="actions-col">
        <RowActions
          alignEnd
          showDuplicate
          onEdit={() => history.push(`/create-work-order-template/${template.value}`)}
          onDelete={(e) => {
            e.preventDefault();
            deleteTemplate(template.value);
          }}
          onDuplicate={(e) => {
            e.preventDefault();
            copy();
          }}
        />
      </td>
    </tr>
  );
};

export default LabelRow;
